import React, { useEffect, useRef } from "react";

const Escapable = ({ onEscape, children, className }) => {
	const escapeRef = useRef(null);

	useEffect(() => {
		escapeRef.current.focus();
	}, []);

	return (
		<div
			className={className}
			ref={escapeRef}
			onKeyDown={({ key }) => {
				if (key === "Escape") {
					onEscape();
				}
			}}
			tabIndex={0}
		>
			{children}
		</div>
	);
};

export default Escapable;
